const SINGLE_SAVED_SEARCH_QUERY_KEY = "saved-search-filters:id";
const SAVED_SEARCH_MUTATION_KEY = "saved-search-filters:mutate";

export const savedSearchFiltersQueryKeys = {
    getById: (savedSearchId?: string | null) => {
        const base = [SINGLE_SAVED_SEARCH_QUERY_KEY] as const;

        return savedSearchId ? ([...base, savedSearchId] as const) : base;
    },
} as const;

export const savedSearchMutationKeys = {
    update: () => [SAVED_SEARCH_MUTATION_KEY, "update"] as const,
} as const;
